import { Reveal, Overline, CTA } from "./primitives";
import { ENROLL_URL } from "../../config";

const becomings = [
  "Create opportunities",
  "Navigate challenges",
  "Build meaningful relationships",
  "Generate wealth",
  "Keep growing no matter what life throws at you",
];

const questions = [
  "What would you finally have the courage to start?",
  "What \u201csomeday\u201d dream would quietly become normal?",
];

export const WhyFinal = () => (
  <>
    {/* One Last Thought */}
    <section id="one-last-thought" data-testid="onelastthought-section" className="bg-alabaster py-28 md:py-40">
      <div className="mx-auto max-w-[1000px] px-6 md:px-10">
        <Reveal><Overline>One Last Thought</Overline></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 max-w-3xl font-display text-3xl font-medium leading-[1.12] tracking-tight text-ink sm:text-4xl lg:text-5xl">
            The biggest investment you'll ever make isn't in a stock, a business, or a piece of
            <span className="italic text-terracotta"> real estate.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-8 font-sans text-lg font-light text-stonegray">
            It's in becoming the kind of person who can:
          </p>
          <ul className="mt-4 grid gap-x-10 gap-y-3 sm:grid-cols-2">
            {becomings.map((b) => (
              <li key={b} className="flex items-baseline gap-3 font-display text-xl text-ink md:text-2xl">
                <span className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-terracotta" />
                {b}
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-10 font-sans text-lg font-light text-stonegray">
            That's what this community is designed to help you do.
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <p className="mt-14 font-display text-2xl font-medium leading-snug text-ink md:text-3xl">
            Imagine your life <span className="italic text-terracotta">one year</span> from today.
          </p>
        </Reveal>
        <div className="mt-6 space-y-4">
          {questions.map((q, i) => (
            <Reveal key={q} delay={0.15 + i * 0.08}>
              <p className="font-sans text-xl font-light text-stonegray md:text-2xl">{q}</p>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <p className="mt-12 font-display text-2xl leading-snug text-ink md:text-3xl">
            Your bigger life doesn't begin when you feel confident. It begins the moment you become
            <span className="italic text-terracotta"> courageous enough to find out what's possible.</span>
          </p>
        </Reveal>
      </div>
    </section>

    {/* Final CTA — cinematic dark band */}
    <section id="join" data-testid="final-cta-section" className="relative overflow-hidden bg-ink py-32 text-center text-ivory md:py-48">
      <div className="grain-overlay opacity-[0.06]" />
      <div className="glow-float pointer-events-none absolute left-1/2 top-1/2 -z-0 h-[36rem] w-[36rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-terracotta/15 blur-[120px]" />
      <div className="relative mx-auto max-w-[900px] px-6 md:px-10">
        <Reveal><Overline className="text-terracotta">The Next Chapter</Overline></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-8 font-display text-5xl font-medium leading-[1] tracking-tight text-ivory sm:text-6xl lg:text-7xl">
            Your next chapter <span className="italic text-terracotta">is waiting.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mx-auto mt-8 max-w-xl font-display text-2xl italic leading-snug text-ivory/85 md:text-3xl">
            Come for the breakthrough. <span className="text-terracotta">Stay to create the damn thing.</span>
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-12 flex justify-center">
            <CTA href={ENROLL_URL} data-testid="final-cta" className="!px-10 !py-5">
              Join Creating Wealth Through Community
            </CTA>
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 font-display text-lg italic text-ivory/70">Start building your bigger life today.</p>
        </Reveal>
      </div>
    </section>

    {/* Footer */}
    <footer data-testid="site-footer" className="bg-ink pb-14 text-ivory/50">
      <div className="mx-auto flex max-w-[1400px] flex-col items-start justify-between gap-8 border-t border-ivory/10 px-6 pt-12 md:flex-row md:items-center md:px-10">
        <div>
          <a href="#top" className="font-display text-2xl text-ivory">Creating Wealth</a>
          <p className="mt-2 max-w-xs font-sans text-sm font-light">
            Creating Wealth Through Community. Build a bigger life — without becoming someone else.
          </p>
        </div>
        <div className="flex flex-wrap gap-x-8 gap-y-2 font-sans text-sm">
          <a href="#story" className="transition-colors hover:text-ivory">Story</a>
          <a href="#journey" className="transition-colors hover:text-ivory">Journey</a>
          <a href="#community" className="transition-colors hover:text-ivory">Community</a>
          <a href="#pricing" className="transition-colors hover:text-ivory">Pricing</a>
          <a href={ENROLL_URL} className="transition-colors hover:text-terracotta">Join</a>
        </div>
      </div>
      <p className="mx-auto mt-10 max-w-[1400px] px-6 font-sans text-xs font-light text-ivory/35 md:px-10">
        © {new Date().getFullYear()} Creating Wealth Through Community. Individual results shared reflect personal experience and are not typical or guaranteed.
      </p>
    </footer>
  </>
);
